<i class="search-icon icon-search" (click)="searchToggle()"></i>
<div
  class="overlay"
  [class.active]="isShowOverlay"
  [class.translucent]="isSearchEmpty && !searchText"
>
  <div class="app-container-basic">
    <i class="close-btn icon-close" (click)="close()"></i>
    <div class="search-section">
      <i class="back-btn icon-back" (click)="close()"></i>
      <input
        type="text"
        [(ngModel)]="searchText"
        (ngModelChange)="inputValueChanged($event)"
        placeholder="{{ 'Search.Search' | translate }}"
      />
      <button class="clear-btn" (click)="clear()">
        {{ 'Search.Clear' | translate }}
      </button>
    </div>
    <div class="game-section" #gameSection>
      <div *ngIf="!isSearchEmpty" class="game-container">
        <lynx-game-card
          *ngFor="let game of games; index as i"
          id="game-{{ i }}"
          [game]="game"
        >
        </lynx-game-card>
      </div>

      <div *ngIf="isSearchEmpty" class="game-empty">
        <span class="icon icon-search"></span>
        <h4 class="title">
          <ng-container *ngIf="searchText; else default">
            {{ 'Search.NoResult.0' | translate : { value: searchText } }}
            <br />{{ 'Search.NoResult.1' | translate }}
          </ng-container>
          <ng-template #default>
            {{ 'Search.PleaseType' | translate }}
          </ng-template>
        </h4>
      </div>
    </div>
  </div>
</div>
